/**
 * @file 组件初始化入口
 */

import TSelectTree from './select-tree.vue'

TSelectTree.install = Vue => {
  Vue.component(TSelectTree.name, TSelectTree)
}

export {
  TSelectTree
}



// WEBPACK FOOTER //
// ./src/module/select-tree/index.js